module.exports = __webpack_public_path__ + "assets/img/btn-download-pc-2f6a6b79.png";